import { useEffect } from "react";

export default function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Outlaw Creative (the geometry of life)` : "Outlaw Creative (the geometry of life)";
    const m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description);
  }, [title, description]);
}
